// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"308":"f7ff9b32","324":"72b3ad69","560":"087fae0c"}[chunkId] + ".js";
};